var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 274,
    viewBox: "0 0 46 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.110962 144.199L11.7723 144.199L45.8595 273.565L17.1545 273.565L0.110962 144.199Z",
    fill: "#675653",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.110962 4.07324C0.110962 1.8641 1.90182 0.0732422 4.11096 0.0732422L7.77235 0.0732422C9.98148 0.0732422 11.7723 1.8641 11.7723 4.07324L11.7723 145.067L0.110962 145.067L0.110962 4.07324Z",
    fill: "url(#paint0_linear_9_1560)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39014 5.28259L31.507 83.4231L31.507 180.665L6.39014 76.4773L6.39014 5.28259Z",
    fill: "#E0C9C9",
    fillOpacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 80.2519,
    y2: -1,
    transform: "matrix(0.309123 0.951022 -0.956632 0.2913 5.49304 6.15076)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 80.7519,
    y2: -0.5,
    transform: "matrix(0.309123 0.951022 -0.956632 0.2913 5.49304 19.1742)",
    stroke: "#DFAA93",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 80.7519,
    y2: -0.5,
    transform: "matrix(0.309123 0.951022 -0.956632 0.2913 5.49304 31.3295)",
    stroke: "#DFAA93",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 80.7519,
    y2: -0.5,
    transform: "matrix(0.309123 0.951022 -0.956632 0.2913 5.49304 43.4846)",
    stroke: "#DFAA93",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 80.7519,
    y2: -0.5,
    transform: "matrix(0.309123 0.951022 -0.956632 0.2913 5.49304 55.6398)",
    stroke: "#DFAA93",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 80.7519,
    y2: -0.5,
    transform: "matrix(0.309123 0.951022 -0.956632 0.2913 5.49304 67.795)",
    stroke: "#DFAA93",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6396 84.8185C21.6396 82.6093 23.4305 80.8185 25.6396 80.8185L34.6832 80.8185C36.8924 80.8185 38.6832 82.6093 38.6832 84.8185L38.6832 270.96L21.6396 270.96L21.6396 84.8185Z",
    fill: "url(#paint1_linear_9_1560)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6099 80.8185C30.6099 80.8185 31.0975 100.693 30.1614 113.377C29.2644 125.532 32.8525 133.346 30.6099 144.199",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_1560",
    x1: 6.86229,
    y1: 72.9013,
    x2: 2.25911,
    y2: 72.9013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3B34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_1560",
    x1: 31.507,
    y1: 176.324,
    x2: 24.7793,
    y2: 176.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3B34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D6B68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetStandard);
export default __webpack_public_path__ + "static/media/net-standard.6f85d92a3f4747d7f1965d91536141e8.svg";
export { ForwardRef as ReactComponent };